import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface MagicPayload {
  evaluationId: string;
  filters?: any;
  iss?: string;
  exp?: number;
}

@Injectable({ providedIn: "root" })
export class MagicLinkService {
  private STORAGE_KEY = "magicLinkToken";
  private STORAGE_PAYLOAD_KEY = "magicLinkPayload";

  private _isMagic$ = new BehaviorSubject<boolean>(false);
  isMagic$ = this._isMagic$.asObservable();

  private _payload$ = new BehaviorSubject<MagicPayload | null>(null);
  payload$ = this._payload$.asObservable();

  constructor() {
    const token = sessionStorage.getItem(this.STORAGE_KEY);
    const payloadJson = sessionStorage.getItem(this.STORAGE_PAYLOAD_KEY);
    if (token && payloadJson) {
      try {
        const payload = JSON.parse(payloadJson) as MagicPayload;
        this._payload$.next(payload);
        this._isMagic$.next(true);
      } catch {
        this.clear();
      }
    }
  }

  setMagic(token: string, payload: MagicPayload) {
    sessionStorage.setItem(this.STORAGE_KEY, token);
    sessionStorage.setItem(this.STORAGE_PAYLOAD_KEY, JSON.stringify(payload));
    this._payload$.next(payload);
    this._isMagic$.next(true);
  }

  clear() {
    sessionStorage.removeItem(this.STORAGE_KEY);
    sessionStorage.removeItem(this.STORAGE_PAYLOAD_KEY);
    this._payload$.next(null);
    this._isMagic$.next(false);
  }

  getPayload(): MagicPayload | null {
    return this._payload$.value;
  }

  isActive(): boolean {
    return this._isMagic$.value;
  }

  getTokenFromStorage(): string | null {
    return sessionStorage.getItem(this.STORAGE_KEY);
  }
}
